/*

  // Add/Remove content from the DOM with radio and checkbox checks.
  // Note this will not work as-is if you need more than one --content item for a --container

  <div class=".js-form-content-reveal--container">

    <input type="radio" class="js-form-content-reveal" data-form-content-reveal-action="show"> // shows
    <input type="radio" class="js-form-content-reveal" data-form-content-reveal-action="hide"> // hides
    <input type="checkbox" class="js-form-content-reveal"> // shows on checked, hides when unchecked

    <div class=".js-form-content-reveal--content>...</div>

  </div>

 */

import $ from 'jquery';

const selectors = {
  CONTAINER: '.js-form-content-reveal--container',
  CONTENT: '.js-form-content-reveal--content',
  INPUT: 'input.js-form-content-reveal'
};

const classes = {
  CONTENT_WRAPPER: 'js-form-content-reveal--wrapper'
};

const booleanDataAttrs = {
  SHOW: 'data-form-content-reveal--show',
  HIDE: 'data-form-content-reveal--hide'
};

$(_ => {

  $(selectors.CONTAINER).each((index, el) => {

    const $container = $(el);
    const $content = $container.find(selectors.CONTENT);
    if ($content.length === 0) return;

    const $wrapper = $(`<div class="${classes.CONTENT_WRAPPER}" />`);
    const state = {
      $content,
      $wrapper,
      visible: false
    };

    // delay in case $content or anything inside it needs to be initialized
    window.requestAnimationFrame(_ => {
      $content.after($wrapper);
      $content.detach();
    });

    $container.find(`${selectors.INPUT}[type=radio]`).each((index, el) => {
      initRadio(el, state);
    });

    $container.find(`${selectors.INPUT}[type=checkbox]`).each((index, el) => {
      initCheckbox(el, state);
    });

  });
});


function initRadio(el, state) {
  const $el = $(el);
  const shows = $el.is(`[${booleanDataAttrs.SHOW}]`);

  $el.on('change', _ => {
    if (shows) {
      showContent(state);
    } else {
      hideContent(state);
    }
  });
}


function initCheckbox(el, state) {
  const $el = $(el);

  $el.on('change', _ => {
    if ($el.is(':checked')) {
      showContent(state);
    } else {
      hideContent(state);
    }
  });
}


function showContent(state) {
  const $content = state.$content;
  const $wrapper = state.$wrapper;

  if (!state.visible) {
    $content.stop(true);
    $wrapper.append($content);
    $content.slideDown();
    state.visible = true;
  }
}


function hideContent(state) {
  const $content = state.$content;

  if (state.visible) {
    $content.stop(true);
    $content.slideUp({
      complete() {
        $content.detach();
      }
    });
    state.visible = false;
  }
}
